module.exports = __webpack_public_path__ + "static/media/media_web.7de5888e.png";